<template>
  <section id="recruitment" class="patient-recruitment-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">系统搭建</h2>
        <div class="title-underline"></div>
        <p class="section-description">
          如果您或者您的企业需要搭建医疗系统，
          请输入您的联系方式，我们会派遣工作人员与您联系。
        </p>
      </div>
      
      <div class="form-container">
        <div 
          class="form-card"
          v-motion
          :initial="{ opacity: 0, y: 50 }"
          :visible="{ opacity: 1, y: 0 }"
          :transition="{ duration: 0.8 }"
        >
          <h3 class="form-title"></h3>
          
          <form @submit.prevent="handleSubmit" class="recruitment-form">
            <div class="form-grid">
              <div class="form-field">
                <label for="company" class="field-label">企业名称 <span class="required">*</span></label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  v-model="formData.company"
                  required
                  class="field-input"
                  placeholder="请输入您的企业名称"
                />
              </div>
              
              <div class="form-field">
                <label for="contactName" class="field-label">联系人 <span class="required">*</span></label>
                <input
                  type="text"
                  id="contactName"
                  name="contactName"
                  v-model="formData.contactName"
                  required
                  class="field-input"
                  placeholder="请输入联系人姓名"
                />
              </div>
              
<div class="form-field">
  <label for="phone" class="field-label">手机号码 <span class="required">*</span></label>
  <input
    type="tel"
    id="phone"
    name="phone"
    v-model="formData.phone"
    required
    class="field-input"
    :class="{ 'invalid': formData.phone && !validatePhone(formData.phone) }"
    placeholder="请输入您的手机号码"
    @blur="validatePhone(formData.phone)"
  />
  <div 
    v-if="formData.phone && !validatePhone(formData.phone)" 
    class="error-message"
  >
    请输入正确的手机号码
  </div>
</div>
              
              <div class="form-field">
                <label for="email" class="field-label">电子邮箱</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  v-model="formData.email"
                  class="field-input"
                  placeholder="请输入您的电子邮箱"
                />
              </div>
              
              <div class="form-field">
                <label for="systemType" class="field-label">系统类型 <span class="required">*</span></label>
                <select
                  id="systemType"
                  name="systemType" 
                  v-model="formData.systemType"
                  required
                  class="field-input"
                >
                  <option value="">请选择</option>
                  <option value="1">医院管理系统</option>
                  <option value="2">诊所管理系统</option>
                  <option value="3">临床研究系统</option>
                  <option value="4">其他</option>
                </select>
              </div>
              
              <div class="form-field">
                <label for="budget" class="field-label">预算范围</label>
                <select
                  id="budget"
                  name="budget"
                  v-model="formData.budget"
                  class="field-input"
                >
                  <option value="">请选择</option>
                  <option value="1">0-5万元</option>
                  <option value="2">5-10万元</option>
                  <option value="3">10-20万元</option>
                  <option value="4">20万元以上</option>
                </select>
              </div>
            </div>
            
            <div class="form-field">
              <label for="requirements" class="field-label">具体需求</label>
              <textarea
                id="requirements"
                name="requirements"
                v-model="formData.requirements"
                rows="4"
                class="field-input field-textarea"
                placeholder="请详细描述您的系统需求"
              ></textarea>
            </div>
            
            <div class="consent-section">
              <label class="consent-label">
                <input
                  type="checkbox"
                  name="consent"
                  v-model="formData.consent"
                  class="consent-checkbox"
                />
                <span class="consent-text">
                  我已阅读并同意<a href="#" class="consent-link">《隐私政策》</a>和<a href="#" class="consent-link">《服务条款》</a>，
                  同意贵公司收集和使用我的个人信息用于系统搭建服务。 <span class="required">*</span>
                </span>
              </label>
            </div>
            
            <div class="submit-section">
              <button
                type="submit"
                :disabled="isSubmitting"
                class="submit-button"
              >
                <span v-if="isSubmitting" class="submitting-text">
                  <i class="spinner-icon"></i>
                  提交中...
                </span>
                <span v-else class="submit-text">提交信息</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive } from 'vue'

const isSubmitting = ref(false)

const formData = reactive({
  company: '',
  contactName: '',
  phone: '',
  email: '',
  systemType: '',
  budget: '',
  requirements: '',
  consent: false
})
// 手机号校验正则表达式
const validatePhone = (phone) => {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone)
}
const handleSubmit = async (e) => {
  e.preventDefault()
  
  if (!formData.consent) {
    alert('请同意隐私政策和服务条款')
    return
  }
  
  isSubmitting.value = true
  
  try {
    const response = await fetch('https://jidujiankang.com/wx/buildSystem', {
      method: 'POST',
      credentials: 'include', // 相当于 withCredentials: true
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        company: formData.company,
        contactName: formData.contactName,
        phone: formData.phone,
        email: formData.email,
        systemType: formData.systemType,
        budget: formData.budget,
        requirements: formData.requirements
      })
    })
    
    if (response.ok) {
      alert('提交成功！我们的技术顾问将尽快与您联系。')
      Object.assign(formData, {
        company: '',
        contactName: '',
        phone: '',
        email: '',
        systemType: '',
        budget: '',
        requirements: '',
        consent: false
      })
    } else {
      alert('提交失败，请稍后重试')
    }
  } catch (error) {
    console.error('提交错误:', error)
    alert('网络错误，请检查连接后重试')
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.field-input.invalid {
  border-color: #dc2626;
}

.error-message {
  color: #dc2626;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
/* 基础样式 */
.patient-recruitment-section {
  padding: 3rem 0; /* 减小移动设备的上下内边距 */
  background-color: #f9fafb;
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem; /* 基础内边距 */
  box-sizing: border-box; /* 确保padding不会增加总宽度 */
}

/* 响应式容器调整 */
@media (min-width: 640px) {
  .container {
    max-width: 640px;
    padding: 0 1.5rem;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
    padding: 0 2rem;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

/* 标题区域样式 */
.section-header {
  text-align: center;
  margin-bottom: 2rem; /* 移动设备减小间距 */
  padding: 0 0.5rem; /* 增加左右内边距防止内容贴边 */
}

.section-title {
  font-size: 1.75rem; /* 移动设备减小标题大小 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
  line-height: 1.2; /* 优化行高 */
}

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25rem; /* 平板及以上设备增大标题 */
  }
}

.title-underline {
  width: 4rem; /* 移动设备减小下划线长度 */
  height: 0.25rem;
  background-color: #2563eb;
  margin: 0 auto;
  border-radius: 9999px;
}

.section-description {
  color: #374151;
  font-size: 1rem; /* 移动设备减小描述文字 */
  max-width: 100%; /* 移动设备使用全宽 */
  margin: 1rem auto 0;
  line-height: 1.5; /* 优化行高提高可读性 */
  padding: 0 1rem; /* 增加内边距 */
}

@media (min-width: 768px) {
  .section-description {
    max-width: 36rem; /* 平板及以上限制最大宽度 */
  }
}

/* 表单容器样式 */
.form-container {
  width: 100%;
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 1rem; /* 增加内边距防止贴边 */
  box-sizing: border-box;
}

.form-card {
  background-color: white;
  padding: 1.5rem; /* 移动设备减小内边距 */
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); /* 减小阴影强度 */
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .form-card {
    padding: 2.5rem; /* 平板及以上增大内边距 */
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.form-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
  text-align: center;
}

/* 表单布局样式 */
.recruitment-form {
  display: grid;
  gap: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr; /* 默认单列布局，适合移动设备 */
  gap: 1.5rem;
}

/* 当屏幕宽度足够时变为双列布局 */
@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* 使用gap代替margin */
}

.field-label {
  display: block;
  font-weight: 500;
  color: #374151;
  font-size: 0.95rem; /* 稍小的标签文字 */
}

.required {
  color: #ef4444;
}

.field-input {
  padding: 0.75rem; /* 适当减小输入框内边距 */
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  box-sizing: border-box; /* 确保输入框不会超出容器 */
}

/* 优化输入框聚焦效果 */
.field-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* 文本区域样式 */
.field-textarea {
  resize: vertical;
  min-height: 100px; /* 移动设备减小最小高度 */
}

@media (min-width: 768px) {
  .field-textarea {
    min-height: 120px; /* 平板及以上增大最小高度 */
  }
}

/* 同意条款区域 */
.consent-section {
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.consent-label {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  flex-wrap: wrap; /* 允许文本换行 */
}

.consent-checkbox {
  margin-top: 0.25rem;
  margin-right: 0.75rem;
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db;
  color: #2563eb;
  flex-shrink: 0; /* 防止复选框被压缩 */
}

.consent-text {
  color: #374151;
  line-height: 1.6; /* 提高行高增强可读性 */
  font-size: 0.9rem; /* 稍小的文字 */
  flex: 1; /* 让文本区域占据剩余空间 */
}

.consent-link {
  color: #2563eb;
  text-decoration: underline;
  word-break: break-all; /* 防止链接过长导致溢出 */
}

.consent-link:hover {
  color: #1d4ed8;
}

/* 提交按钮区域 */
.submit-section {
  text-align: center;
  margin-top: 1.5rem;
}

.submit-button {
  background-color: #2563eb;
  color: white;
  padding: 0.875rem 1.5rem; /* 适当减小按钮内边距 */
  border-radius: 9999px;
  font-size: 1rem; /* 减小按钮文字 */
  font-weight: 600;
  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
  width: 100%; /* 移动设备按钮占满宽度 */
  max-width: 300px; /* 限制最大宽度 */
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .submit-button {
    width: auto; /* 平板及以上恢复自动宽度 */
    padding: 1rem 2rem;
    font-size: 1.125rem;
  }
}

.submit-button:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submitting-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner-icon {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 针对超小屏幕的额外优化 */
@media (max-width: 360px) {
  .patient-recruitment-section {
    padding: 2rem 0;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .form-card {
    padding: 1rem;
  }
  
  .consent-text {
    font-size: 0.85rem;
  }
}
</style>